import guadalupe from "./guadalupe.json";
import filipov from "./filipov.json";
import lezajsk from "./lezajsk.json";
import siluva from "./siluva.json";
import laus from "./laus.json";
import miraculousMedal from "./miraculous-medal.json";
import zion from "./zion.json";
import salette from "./salette.json";
import lourdes from "./lourdes.json";
import pontmain from "./pontmain.json";
import gietrzwald from "./gietrzwald.json";
import knock from "./knock.json";
import fatima from "./fatima.json";
import beauraing from "./beauraing.json";
import banneux from "./banneux.json";
import kibeho from "./kibeho.json";
import mountCarmel from "./mount-carmel";
import { APPARITION_EDITORIAL, apparitionScripture } from "../apparitionEditorial";
import { SUB_TUUM } from "../historicalPrayers";

export const APPARITION_STORIES = Object.fromEntries([
  guadalupe, filipov, lezajsk, siluva, laus, miraculousMedal, zion, salette,
  lourdes, pontmain, gietrzwald, knock, fatima, beauraing, banneux, kibeho, mountCarmel,
].map((story) => {
  const words = story.sections.flatMap((section) => section.paragraphs).join(" ").trim().split(/\s+/).length;
  return [story.id, { ...story, wordCount: words, readingMinutes: Math.ceil(words / 200) }];
}));

export const enrichApparition = (entry) => {
  const story = APPARITION_STORIES[entry.id];
  if (!story) throw new Error(`Missing full story for ${entry.id}`);
  const { shrineWebsite, shrineLinkLabel, ...corrections } = story.corrections || {};
  const retained = entry.sources.filter((s) => s.type === "Prayer" || /prayers taught/i.test(s.label));
  const sources = [...story.sources, ...retained];
  return {
    ...entry, ...corrections, ...APPARITION_EDITORIAL[entry.id], scripture: apparitionScripture(entry), story, overview: story.overview,
    prayer: SUB_TUUM.text, prayerSource: SUB_TUUM,
    history: story.sections.flatMap((section) => section.paragraphs),
    posterSummary: story.posterSummary, reviewed: "September 2026",
    shrine: { ...entry.shrine, ...(shrineWebsite ? { website: shrineWebsite } : {}), ...(shrineLinkLabel ? { linkLabel: shrineLinkLabel } : {}) },
    sources: sources.filter((s, i) => sources.findIndex((other) => other.url === s.url) === i),
  };
};